import { generateRandomId } from "@/react/helpers/generateRandomId";
import { useIsPaywallCustomizationPhase2 } from "@/react/hooks/useIsPaywallCustomizationPhase2";
import type {
  BadgeProperty,
  PaywallCustomization,
  TestimonialProperty,
} from "@/react/types/PaywallCustomization";

const addIds = <T>(input: T): T => ({
  id: generateRandomId(),
  ...input,
});

const serializeTestimonialProperties = (
  testimonialProperties?: PaywallCustomization["testimonial_properties"],
): PaywallCustomization["testimonial_properties"] => {
  if (!testimonialProperties) {
    return { enabled: false, testimonials: [] };
  }

  return {
    ...testimonialProperties,
    testimonials: (testimonialProperties.testimonials || []).map(
      addIds<TestimonialProperty>,
    ),
  };
};

const serializeBadgeProperties = (
  badgeProperties?: PaywallCustomization["badge_properties"],
): PaywallCustomization["badge_properties"] => {
  if (!badgeProperties) {
    return { enabled: false, badges: [] };
  }

  return {
    ...badgeProperties,
    badges: (badgeProperties.badges || []).map(addIds<BadgeProperty>),
  };
};

export const usePaywallCustomization = (
  paywallCustomization?: PaywallCustomization,
): undefined | PaywallCustomization => {
  const isEnabled = useIsPaywallCustomizationPhase2();

  if (!paywallCustomization || !isEnabled) {
    return undefined;
  }

  return {
    ...paywallCustomization,
    badge_properties: serializeBadgeProperties(
      paywallCustomization.badge_properties,
    ),
    testimonial_properties: serializeTestimonialProperties(
      paywallCustomization.testimonial_properties,
    ),
  };
};
